exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.base-div[data-v-4a05935e] {\n    float: right;\n}\na[data-v-4a05935e] {\n    cursor: pointer;\n}\ntbody tr[data-v-4a05935e]:nth-child(odd) {\n    background: rgba(0,0,0,0.3);\n}\ntable[data-v-4a05935e] {\n    min-width: 100%;\n}\ntbody td[data-v-4a05935e],\nthead th[data-v-4a05935e] {\n  padding-left: 20px;\n}\ntbody td[data-v-4a05935e]:first-child,\nthead th[data-v-4a05935e]:first-child {\n  padding-left: 5px;\n}\ntbody td[data-v-4a05935e]:last-child,\nthead th[data-v-4a05935e]:last-child {\n    padding-right: 5px;\n}\n", ""]);

// exports
